(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TTWidInstance", [], factory);
	else if(typeof exports === 'object')
		exports["TTWidInstance"] = factory();
	else
		root["TTWidInstance"] = factory();
})(self, function() {
return 